import 'core-js/modules/web.timers.js';
import { useRef, useEffect } from 'react';

var useMouseMove = function useMouseMove(callback, element) {
  var timeoutRef = useRef();
  var mouseEventHandler = function mouseEventHandler(e) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      if (element) {
        callback(e);
      }
    }, 100);
  };
  useEffect(function () {
    if (element) {
      element.addEventListener('mouseover', mouseEventHandler);
      element.addEventListener('mouseenter', mouseEventHandler);
      element.addEventListener('mouseout', mouseEventHandler);
      element.addEventListener('mouseleave', mouseEventHandler);
    }
    return function () {
      if (element) {
        element.removeEventListener('mouseover', mouseEventHandler);
        element.removeEventListener('mouseenter', mouseEventHandler);
        element.removeEventListener('mouseout', mouseEventHandler);
        element.removeEventListener('mouseleave', mouseEventHandler);
      }
    };
  }, [element]);
};

export { useMouseMove };
